import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2768B1",
      d: "M14.061 27.132c-.884-2.636-1.979-7.738-2.44-10.467 0 0-.895-5.781-1.073-7.018-.18-1.237 0-2.628-1.489-3.955C6.92 3.736 2.276.662 1.056.133S-.05.741.072 1.877c.121 1.136.87 9.028 2.05 15.788S5.177 27.94 5.975 29.44s5.646 5.033 6.387 5.53 2.375 1.704 3.255.995c.88-.708.247-2.854.154-3.437s-.823-2.761-1.71-5.396"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#CF1327",
      d: "M26.164 28.045c-.883-2.636-1.978-7.738-2.44-10.467 0 0-.894-5.781-1.073-7.018s0-2.628-1.488-3.955c-2.147-1.941-6.777-5.015-8-5.544-1.224-.528-1.11.597-.999 1.737s.87 9.028 2.047 15.787 3.055 10.276 3.853 11.775 5.646 5.034 6.387 5.53 2.375 1.704 3.255.996.247-2.855.154-3.437c-.093-.583-.812-2.765-1.696-5.404M37.474 23.702c-1.338-3.783-1.513-4.732-3.148-6.3s-5.463-4.839-7.614-5.655c-1.764-.669-1.477.061-1.388.816s.28 1.78.28 1.78c.181 1.438.775 6.213 1.126 7.967.35 1.755.959 4.753 2.304 6.321 1.346 1.568 3.177 2.628 4.53 3.344 1.352.715 4.221 2.157 4.873 2.373.65.215 1.141-.381 1.052-1.672a40.5 40.5 0 0 0-2.015-8.974"
    }, null, -1)
  ])))
}
export default { render: render }